import { Button } from "@pinkyhead/dovekit";
import { ReactComponent as ImagesIcon } from "../../../../assets/icons/regular/images.svg";
import { useParticipationRow } from "./ParticipationRow.hooks";
import { ParticipationRowProps } from "./ParticipationRow.interface";
import { Container } from "./ParticipationRow.styles";

export const ParticipationRow = ({ data }: ParticipationRowProps) => {
  const { redirectTo } = useParticipationRow(data);
  return (
    <Container>
      <div className="image">
        {data.picture
          ? <img src={data.picture?.low} alt="Picture" />
          : <ImagesIcon />
        }
      </div>
      <p className="displayName">{data.name}</p>
      <Button
        size="small"
        variant="text"
        onClick={redirectTo}
      >
        View
      </Button>
    </Container>
  )
}
